import { Css, useComputed } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { AddOnBookOptionFormInput } from "src/routes/projects/change-events/guided/workflows/addOnBookOption/addOnBookOptionWorkflow";

type SelectOptionStepProps = { formState: ObjectState<AddOnBookOptionFormInput> };

export function SelectOptionStep(props: SelectOptionStepProps) {
  const { formState } = props;
  const selectedOptionId = useComputed(() => formState.selectedOptionId.value, [formState]);
  return (
    <div css={Css.df.fdc.gap4.$}>
      <div>
        <h2 css={Css.xl.$}>Select the Option to Add</h2>
        <p css={Css.sm.gray700.$}>Choose an existing on-book product offering option to add to this structure.</p>
      </div>
      {/* TODO: replace with the on-book option picker that sets `formState.selectedOptionId`. */}
      <div css={Css.sm.gray700.$}>
        {selectedOptionId
          ? `Selected option: ${selectedOptionId}`
          : "The option picker is not part of the prototype yet."}
      </div>
    </div>
  );
}
